import React, { useState } from 'react';
import '../../../css/Form.css';
import Select from 'react-select';
import Utils from '../../../helper/Utils';
import UploadFile from '../../../helper/UploadFile';
import ApiGateway from '../../../helper/ApiGateway';
import Loader from '../../../helper/Loader';
import ConfirmPopup from '../../../helper/ConfirmationPopup';

const RoleSection = (props) => {
	// used States:
	const {
		userDetails,
		posts,
		subjects,
		specialize,
		Locations,
		jobCategory,
		toggleHandler,
		handleRenderComp,
		SelectHandler,
		topFunction,
		scrollToBottom,
		requiredFields,
		showSpecialization,
		saveDraft,
		JobDetailsSubjectSelect,
		// dashboardHandler,
		// LockDashboard,
		savedJobCode,
		scrollHandler,
		jobCode,
		campusPref,
		UploadData,
		setSaveTheData,
		setUserDetails,
		parseResumeData,
		loadDataFromResume
	} = props;

		const resumeUploadProcesscode = "EMP_RESUME_UPLOAD";
	const resumeUploadProcesscodeData = UploadData.filter(
		(item) => item.uploadProcessCode === resumeUploadProcesscode
	);
	const [LoaderActive, setLoaderActive] = useState(false);
	const [showAutofillAlert, setShowAutofillAlert] = useState(false);
	const [pendingResume, setPendingResume] = useState(null);

		const getResumeUploadData = (meta, otherParams, filesMeta) => {
		// whenReady("");		
		let fileObj = null;
		if (filesMeta && filesMeta.length > 0 && filesMeta[0].file) {
			fileObj = filesMeta[0].file;
		} else if (meta && meta.length > 0) {
			if (meta[0].file) fileObj = meta[0].file;
			else if (meta[0].preSignedUrl) fileObj = meta[0].preSignedUrl;
			else if (meta[0] instanceof File) fileObj = meta[0];
		} else if (meta instanceof File) {
			fileObj = meta;
		}
		
		let newState = Utils.cloneState(userDetails);
		newState.resume = meta;
		setUserDetails(newState);
		setSaveTheData(true);

		if (!fileObj) {
			console.error("No file found to parse in meta or filesMeta:", meta, filesMeta);
			// Show an alert so the user is immediately aware
			// alert("Could not extract file for parsing. Please check the console.");
			return;
		}

		const formData = new FormData();
		formData.append('file', fileObj);
		
		setPendingResume({ meta, formData });
		setShowAutofillAlert(true);
	};

	const handleAutofillConfirm = (isConfirmed) => {
		setShowAutofillAlert(false);
		if (isConfirmed && pendingResume) {
			setLoaderActive(true);
			ApiGateway.postFiles(`AIHubServices/resume_autofill/parse-resume`, pendingResume.formData, (response)=>{
				try{
					if (response && response.status === 'SUCCESS' && response.data && response.data.success) {
						const data = response.data;
						console.log("Parsed Resume API Response:", data);
						
						if(!Utils.isNullorWhiteSpace(pendingResume.meta) && !Utils.isNullOrEmpty(pendingResume.meta)){
							loadDataFromResume(pendingResume.meta, data);
						}
					} else {
						import('react-toastify').then(({ toast }) => {
							toast.error(response?.data?.message || "Failed to parse resume. Please try again.");
						});
					}
				}catch(ex){
					import('react-toastify').then(({ toast }) => {
						toast.error("An unexpected error occurred while parsing the resume.");
					});
				}
				setLoaderActive(false);
			}, "Protected");
		}
	};

	return (
		<div className="appForm" id='APP-FORM' onScroll={scrollHandler}
			style={{ height: window.innerWidth > 800 ? window.innerHeight - 240 : window.innerWidth <= 375 ? window.innerHeight - 275 : window.innerWidth <= 425 ? window.innerHeight - 260 : window.innerHeight - 260, overflowY: "auto" }}>
			<div className="animated zoomIn">
				<div className="row">
					<div className="col-md-6 col-sm-6">
						{(!Utils.isNullOrEmpty(savedJobCode) || !Utils.isNullOrEmpty(jobCode)) && (
							<label>Job Advertisement No : </label>
						)}
						{" "}
						<span>
							<strong>{!Utils.isNullorWhiteSpace(savedJobCode) ? savedJobCode : jobCode}</strong>
						</span>
					</div>
					<div className="col-md-6 col-sm-6">
						<p className="requiredHeader">
							<span className="requiredTextHeading">*</span> These fields are required
						</p>
					</div>
				</div>

<div className="formWrapper">
			<div className="row">
					<div className="col-xs-12 col-md-3">
											<label className="researchFormLabel ">
												Upload Candidate’s Resume
												<span className='d-block' >
													<span className='upload-accepted-format-indication' >({"Allowed file types:" + resumeUploadProcesscodeData[0]?.fileTypeList.join(',')})</span>
													<span className='upload-accepted-format-indication'>({"File size limit: less than" + " " + resumeUploadProcesscodeData[0]?.fileSizeInKB + "kb"})</span>
												</span>
											</label>
										</div>
				
										<div className="col-lg-3 file-field d-flex align-items-center">
											<div className=''>
												<UploadFile
													callback={getResumeUploadData}
													data={userDetails.resume}
													keyList={resumeUploadProcesscodeData}
													id={resumeUploadProcesscode}
													// errorCallBack={getErrorMsg}
													isMulti={false}
													userDetails={userDetails}
												/>
				
				
												{/* {!ERPUtils.isNullorWhiteSpace(imageUploadError) ?
													<p className="ValidationError" style={{ fontSize: "12px" }}>
														<i className="fa fa-warning warningIcon"></i>&nbsp;
														{imageUploadError}
													</p> : null} */}
											</div>
										</div>
									</div>
								</div>


				<div className="formWrapper">
					<div className="row">
						<div className="col-xs-12 col-md-3">
							<label className="appFormLabel ">
								Post Applied For
							</label>
							<span className="requiredText">*</span>
						</div>
						<div className="col-md-5 col-xs-12">
							<Select
								className={
									requiredFields.commonErrors[0].PostReqError ? 'invalid z-depth-3' : 'z-depth-3'
								}
								value={userDetails.Post}
								onChange={(selected) => toggleHandler(selected, 'Post')}
								options={posts}
							/>
							{requiredFields.commonErrors[0].PostReqError ? (
								<p className="ValidationError">
									<i className="fa fa-warning warningIcon" />Post cannot be empty
								</p>
							) : null}
						</div>
					</div>
				</div>
				{
					!Utils.isNullorWhiteSpace(userDetails.jobCategoryDTO) || !Utils.isNullOrEmpty(jobCategory) ?
						<div className="formWrapper">
							<div className="row">
								<div className="col-xs-12 col-md-3">
									<label className="appFormLabel ">
										Job Category
									</label>
									<span className="requiredText">*</span>
								</div>
								<div className="col-md-5 col-xs-12">
									<Select
										className={
											requiredFields.commonErrors[0].jobCategoryDTOReqError ? (
												'invalid z-depth-3'
											) : (
												' z-depth-3'
											)
										}
										// isDisabled={subjects.length === 0 ? true : false}
										value={userDetails.jobCategoryDTO}
										onChange={(selected) => SelectHandler(selected, 'jobCategoryDTO')}
										options={jobCategory}
									/>
									{requiredFields.commonErrors[0].jobCategoryDTOReqError ? (
										<p className="ValidationError">
											<i className="fa fa-warning warningIcon" />Category cannot be empty
										</p>
									) : null}
								</div>
							</div>
						</div >
						: null
				}
				{/*changed the hardcode to isAcademic ----- userDetails.Post.label === 'Non-Teaching' ?
						((userDetails.Post.label === 'Teaching' || userDetails.Post.label === 'Research') &&
						 ( */}
				{
					Utils.isNullOrEmpty(userDetails.Post) ? null :
						userDetails.Post.isEmployeeCategoryAcademic === false ? (
							<div className="formWrapper">
								<div className="row">
									<div className="col-xs-12 col-md-3">
										<label className="appFormLabel ">
											Category
										</label>
										<span className="requiredText">*</span>
									</div>
									<div className="col-md-5 col-xs-12">
										<Select
											className={
												requiredFields.commonErrors[0].categoryReqError ? (
													'invalid z-depth-3'
												) : (
													' z-depth-3'
												)
											}
											// isDisabled={subjects.length === 0 ? true : false}
											value={userDetails.category}
											onChange={(selected) => SelectHandler(selected, 'category')}
											options={subjects}
										/>
										{requiredFields.commonErrors[0].categoryReqError ? (
											<p className="ValidationError">
												<i className="fa fa-warning warningIcon" />Category cannot be empty
											</p>
										) : null}
									</div>
								</div>
							</div >
						) :
							((userDetails.Post.isEmployeeCategoryAcademic) &&
								<div>
									<div className="formWrapper">
										<div className="row">
											<div className="col-xs-12 col-md-3">
												<label className="appFormLabel ">
													Subject
												</label>
												<span className="requiredText">*</span>
											</div>
											<div className="col-md-5 col-xs-12">
												<Select
													className={
														requiredFields.commonErrors[0].SubjectReqError ? (
															'invalid z-depth-3'
														) : (
															'z-depth-3'
														)
													}
													isDisabled={subjects.length === 0 ? true : false}
													value={userDetails.Subject}
													onChange={(selected) => JobDetailsSubjectSelect(selected, 'Subject')}
													options={subjects}
													// closeMenuOnSelect={false}
													placeholder="Select Multiple"
													isMulti
												/>
												{requiredFields.commonErrors[0].SubjectReqError ? (
													<p className="ValidationError">
														<i className="fa fa-warning warningIcon" />Subject cannot be empty
													</p>
												) : null}
											</div>
										</div>
									</div>

									{
										showSpecialization ? (
											<div className="formWrapper">
												<div className="row">
													<div className="col-md-3 col-xs-12">
														<label className="appFormLabel ">
															Specialisation
														</label>
														<span className="requiredText">*</span>
													</div>
													<div className="col-md-5 col-xs-12">
														<Select
															className={
																requiredFields.commonErrors[0].SpecializationReqError ? (
																	'invalid z-depth-3'
																) : (
																	'z-depth-3'
																)
															}
															isDisabled={userDetails.Subject.length === 0 ? true : false}
															value={userDetails.Specialization}
															// closeMenuOnSelect={false}
															onChange={(selected) => SelectHandler(selected, 'Specialization')}
															options={specialize}
															isMulti
															placeholder="Select Multiple"
															maxMenuHeight={250}
														/>
														{requiredFields.commonErrors[0].SpecializationReqError ? (
															<p className="ValidationError">
																<i className="fa fa-warning warningIcon" />Specialisation cannot be empty
															</p>
														) : null}
													</div>
												</div>
											</div >
										) : null
									}
								</div >
							)
				}
				<div className="formWrapper">
					<div className="row">
						<div className="col-md-3 col-xs-12">
							<label className="appFormLabel ">
								Preferred Campuses
							</label>
							<span className="requiredText">*</span>
						</div>
						<div className="col-md-5 col-xs-12">
							<div className="row">
								<div className="col-md-12 col-xs-12" style={{ padding: "0 15px 6px 14px" }}>
									<Select
										className={
											requiredFields.commonErrors[0].empApplnCampusPrefDTOList1ReqError ? 'invalid z-depth-3' : 'z-depth-3'
										}
										value={userDetails.empApplnCampusPrefDTOList1}
										onChange={(selected) => SelectHandler(selected, 'empApplnCampusPrefDTOList1', 0)}
										options={Utils.getUnselectedOptions(Locations, campusPref, "campusPreference")}
										// closeMenuOnSelect={false}
										// isMulti
										placeholder="Select 1st Preference"
										maxMenuHeight={200}
										isClearable
									/>
									{requiredFields.commonErrors[0].empApplnCampusPrefDTOList1ReqError ? (
										<p className="ValidationError">
											<i className="fa fa-warning warningIcon" />Campus cannot be empty
										</p>
									) : null}
								</div>
							</div>
							{/* </div> */}
							<div className="row">
								<div className="col-md-12 col-xs-12" style={{ padding: "0 15px 6px 14px" }}>
									<Select
										// className={
										// 	requiredFields.commonErrors[0].empApplnCampusPrefDTOList2ReqError ? 'invalid z-depth-3' : 'z-depth-3'
										// }
										value={userDetails.empApplnCampusPrefDTOList2}
										onChange={(selected) => SelectHandler(selected, 'empApplnCampusPrefDTOList2', 1)}
										options={Utils.getUnselectedOptions(Locations, campusPref, "campusPreference")}
										// closeMenuOnSelect={false}
										// isMulti
										placeholder="Select 2nd Preference"
										maxMenuHeight={200}
										isClearable
									/>
									{/* {requiredFields.commonErrors[0].empApplnCampusPrefDTOList2ReqError ? (
								<p className="ValidationError">
									<i className="fa fa-warning warningIcon" />Campus cannot be empty
								</p>
							) : null} */}
								</div>
							</div>
							<div className="row">
								<div className="col-md-12 col-xs-12" style={{ padding: "0 15px 0 14px" }}>
									<Select
										// className={
										// 	requiredFields.commonErrors[0].empApplnCampusPrefDTOListReqError ? 'invalid z-depth-3' : 'z-depth-3'
										// }
										value={userDetails.empApplnCampusPrefDTOList3}
										onChange={(selected) => SelectHandler(selected, 'empApplnCampusPrefDTOList3', 2)}
										options={Utils.getUnselectedOptions(Locations, campusPref, "campusPreference")}
										// closeMenuOnSelect={false}
										// isMulti
										placeholder="Select 3rd Preference"
										maxMenuHeight={200}
										isClearable
									/>
									{/* {requiredFields.commonErrors[0].empApplnCampusPrefDTOListReqError ? (
								<p className="ValidationError">
									<i className="fa fa-warning warningIcon" />Campus cannot be empty
								</p>
							) : null} */}
								</div>
							</div>
						</div>
					</div>
				</div >
				<br />
				<div className="formWrapper">
					<div className="row">
						<div className="col-sm-5 parentDiv">
							<button className="RoleSaveDraft z-depthButton" name="saveDraft" onClick={saveDraft}>
								Save Draft
							</button>
						</div>
						<div className="col-sm-5 parentDiv">
							<button
								className="nextButton z-depthButton"
								name="PersonalDetails"
								onClick={() => handleRenderComp("PersonalDetails")}
							>
								Next
								<i className="fas fa-chevron-right ml-4 " style={{ color: "#ffffff" }} ></i>
							</button>
						</div>
					</div>
				</div>
				<button onClick={topFunction} id="myBtnUp">
					<div className="UpArrow" />
				</button>
				<button onClick={scrollToBottom} id="myBtnDown">
					<div className="downArrow" />
				</button>
			</div >
			{LoaderActive ? <Loader open={LoaderActive} LoaderType={1} /> : null}
			{showAutofillAlert && (
				<ConfirmPopup
					open={showAutofillAlert}
					title="Warning"
					msg="Do you want to autofill the form details from your uploaded resume?"
					icon={<i className="fa fa-info-circle warningIcon" />}
					confirm={() => handleAutofillConfirm(true)}
					cancel={() => handleAutofillConfirm(false)}
				/>
			)}
		</div >
	);
};

export default RoleSection;
